import { z } from 'zod';
import { standardListFilterSchema } from './standard-list-filter.model';

export const standardDetailFilterSchema = standardListFilterSchema.extend({
  questionId: z.coerce.string().optional(),
});

export type StandardDetailFilterSchema = z.infer<typeof standardDetailFilterSchema>;
